import AceEditor from "react-ace";
import "./ace-queryinput";
import "ace-builds/src-noconflict/ext-language_tools";
import "./custom-lucene-mode";
import "ace-builds/webpack-resolver";
export default AceEditor;
